// «Powered by Redy» en las páginas que ve el cliente de un local: a dónde lleva
// y con qué etiquetas. useredy.com mide con Vercel Web Analytics, que lee los
// `utm_*` de la URL de llegada. Sin ellos estas visitas contaban como tráfico
// directo: los links llevan `rel="noreferrer"`, así que ni el referrer llega.
//
// Cómo leerlo en el panel de Vercel:
//   utm_medium   = powered_by                  → todas las visitas desde tiendas
//   utm_source   = <slug del local>            → qué tienda las manda
//   utm_campaign = storefront | venue          → página de pedidos o del venue
//   utm_content  = badge | footer | table_badge → dónde tocaron

/** Sitio de Redy: a donde lleva todo «Powered by Redy» de las páginas del cliente. */
export const REDY_SITE_URL = "https://useredy.com"

export type PoweredByCampaign = "storefront" | "venue"
export type PoweredByPlacement = "badge" | "footer" | "table_badge"

/**
 * URL absoluta (funciona igual en el dominio propio del local) a useredy.com
 * con las etiquetas UTM. Sin slug, va sin `utm_source` del local: nunca se
 * inventa uno.
 */
export function poweredByRedyUrl(opts: {
  slug: string | null | undefined
  campaign: PoweredByCampaign
  placement: PoweredByPlacement
}): string {
  const url = new URL(REDY_SITE_URL)
  const slug = (opts.slug ?? "").trim()
  url.searchParams.set("utm_source", slug || "redy_store")
  url.searchParams.set("utm_medium", "powered_by")
  url.searchParams.set("utm_campaign", opts.campaign)
  url.searchParams.set("utm_content", opts.placement)
  return url.toString()
}
